import { WsCalls } from '@/store/services/wsCalls';

// initial state
const state = () => ({
  cupons: [],
  loadingCupons: true
})

// getters
const getters = {
  getCupons: (state) => {
    return state.cupons;
  },
  freteGratis: (state) => {
    return state.cupons.find(a => a.type_coupon	== 2) ? true : false;
  }
}

// actions
const actions = {
  async loadCupons ({ commit, rootGetters }) {
    commit('setLoadingCupons', true);
    return new Promise((resolve) => {
      WsCalls.callMethodWS('GET', 'cupons', rootGetters['main/getConfig']).then(function (response) {
        if (response.data.cod == 100 && response.data.return != null) {
          commit('loadCupons', response.data.return);
          commit('setLoadingCupons', false);
          resolve(true);
        } else {
          commit('loadCupons', []);
          commit('setLoadingCupons', false);
          resolve(false);
        }
      });
    });
  },
  async checkCupom ({ rootGetters }, cod) {
    return new Promise((resolve) => {
      WsCalls.callMethodWS('GET', 'cupom', rootGetters['main/getConfig'], null, { 'cod': cod }).then(function (response) {
        resolve(response.data);
      });
    });
  },
  async addCupom ({ commit, rootGetters }, cupom) {
    return new Promise((resolve) => {
      WsCalls.callMethodWS('POST', 'cupom', rootGetters['main/getConfig'], { 'id_coupon': cupom.id_coupon }).then(function (response) {
        if (response.data.cod == 200) {
          commit('addCupom', cupom);
        }
        resolve(response.data);
      });
    });
  },
  async delCupom ({ commit, rootGetters }, cupom) {
    return new Promise((resolve) => {
      WsCalls.callMethodWS('DELETE', 'cupom', rootGetters['main/getConfig'], { 'id_coupon': cupom.id_coupon }).then(function (response) {
        if (response.data.cod == 300) {
          commit('delCupom', cupom);
        } 
        resolve(response.data);
      });
    });
  },
}

// mutations
const mutations = {
  loadCupons (state, cupons) {
    state.cupons = cupons;
  },
  addCupom (state, cupom) {
    state.cupons.push(cupom);
  },
  delCupom (state, cupom) {
    state.cupons = state.cupons.filter(a => a.id_coupon != cupom.id_coupon );
  },
  setLoadingCupons (state, status) {
    state.loadingCupons = status;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}